import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'
import { Features } from '@/utils/featureFlag/features'

import { Integrations } from './integrations'

export const integrationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/integrations',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (!context.isFeatureEnabled!(Features.INTEGRATIONS_ENABLED)) {
      throw redirect({
        to: '/',
      })
    }
  },
  component: Integrations,
})
